/* eslint-disable unicorn/no-nested-ternary */
// ✅ React
import React from "react";

// ✅ Ant Design Components & Icons
import { Alert, Button, notification, Popover, Tag } from "antd";
import {
  FileProtectOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

// ✅ Custom UI Components
import H3FormInput from "@Uilib/h3FormInput";
import PRZSelect from "../../../../Common/UI/PRZSelect";
import PushIRPButtons from "../../../Invoice/ViewInvoice/PushIRPButtons";

// ✅ Helpers / Constants
import Helpers from "../../../../../apis/helpers";
import { toISTDate } from "../../../../../apis/constants";

function ViewCreditNoteEInvoiceInfo({
  currentCN,
  isReturnSlip,
  user,
  setCancellationReasonIRP,
  cancellationReasonIRP,
  reasonOptions,
  setCancellationRemark,
  cancellationRemark,
  showErrorIRN,
  setShowErrorIRN,
  setCancellationRemarkPop,
  cancelIRP,
  getCNById,
  cancelIRPLoading,
  pushCnToIRPLoading,
  pushCnToIRP,
}) {
  return (
    user?.tenant_info?.sales_config?.addons?.e_invoicing
      ?.is_active &&
    Helpers.getPermission(
      Helpers.permissionEntities.E_INVOICE,
      Helpers.permissionTypes.READ,
      user
    ) &&
    user.user_tenants.find(
      (tenant) => tenant.tenant_id === user.tenant_info.tenant_id
    )?.is_e_way_bill_enabled &&
    !["SENT_FOR_APPROVAL", "DRAFT", "VOID"].includes(
      currentCN?.status
    ) && (
      <div
        className="view-cn__e-inv-info"
        style={{ marginTop: "5px" }}
      >
        {currentCN?.e_invoice_status === "PUSHED" &&
          currentCN?.e_canceled_date === null && (
          <Alert
            className="e-invoice-alert-pushed"
            message={
              <React.Fragment>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <div>
                      <span>
                        <FileProtectOutlined
                          style={{
                            color: "#52c41a",
                            marginRight: "5px",
                          }}
                        />{" "}
                      </span>
                        e-lnvoice <Tag color="#87d068">PUSHED</Tag>{" "}
                        An IRN and a QR code has been generated{" "}
                      <span
                        className="copy-irn"
                        onClick={() => {
                          navigator.clipboard.writeText(
                            currentCN?.irn
                          );
                          notification.success({
                            message: "IRN Copied",
                            placement: "top",
                            duration: 4,
                          });
                        }}
                      >
                          Copy IRN
                      </span>
                    </div>
                    {currentCN?.e_invoice_errors?.length > 0 &&
                        currentCN?.e_invoice_errors[0]?.length >
                        0 && (
                      <div>
                        <div className="e-invoice-error-messages">
                          {currentCN?.e_invoice_errors?.map(
                            (error, index) => (
                              <div
                                key={index}
                                className="e-invoice-error-message"
                                style={{
                                  backgroundColor: "#fff1f0",
                                }}
                              >
                                <span>
                                  <ExclamationCircleOutlined
                                    style={{
                                      color: "#ff4d4f",
                                      marginRight: "5px",
                                    }}
                                  />{" "}
                                </span>
                                {error}
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  {Helpers.getPermission(
                    Helpers.permissionEntities.E_INVOICE,
                    Helpers.permissionTypes.UPDATE,
                    user
                  ) && (
                    <Popover
                      placement="topRight"
                      trigger="click"
                      title={
                        <div style={{ width: "280px" }}>
                              Are you sure to cancel this e-Invoice?
                        </div>
                      }
                      content={
                        <React.Fragment>
                          <div style={{ marginBottom: "10px" }}>
                            <label className="orgFormLabel">
                                  Reason for cancellation
                              <span style={{ color: "red" }}>
                                {" "}
                                    *
                              </span>
                            </label>
                            <PRZSelect
                              placeholder="Select a reason"
                              onChange={(value) =>
                                setCancellationReasonIRP(value)
                              }
                              dropdownStyle={{ zIndex: 9999 }}
                              value={cancellationReasonIRP}
                              options={reasonOptions}
                            />
                          </div>
                          <H3FormInput
                            name="cancellation remark"
                            type="text"
                            label="Remarks"
                            containerClassName="orgInputContainer"
                            inputClassName="orgFormInput"
                            labelClassName="orgFormLabel"
                            placeholder=""
                            onChange={(event) =>
                              setCancellationRemark(
                                event.target.value
                              )
                            }
                            value={cancellationRemark}
                            maxlength="50"
                            required
                            showError={
                              showErrorIRN === "VOID" &&
                                  !cancellationRemark
                            }
                          />
                          <div className="IRN__cancellation-buttons">
                            <Button
                              onClick={() => {
                                setShowErrorIRN("VOID");
                                if (
                                  cancellationRemark &&
                                      cancellationReasonIRP
                                ) {
                                  setCancellationRemarkPop(false);
                                  cancelIRP(
                                    {
                                      irn: currentCN?.irn,
                                      tenant_id:
                                            currentCN?.tenant_id,
                                      cn_id: currentCN.cn_id,
                                      cancel_reason:
                                            cancellationReasonIRP,
                                      cancel_remark:
                                            cancellationRemark,
                                    },
                                    () => {
                                      setCancellationRemark("");
                                      setCancellationReasonIRP(
                                        ""
                                      );
                                      setShowErrorIRN("");
                                      getCNById(
                                        Helpers.getTenantEntityPermission(
                                          user?.user_tenants,
                                          Helpers
                                            .permissionEntities
                                            .CREDIT_NOTE,
                                          Helpers.permissionTypes
                                            .READ
                                        ).join(",") ||
                                            user?.tenant_info
                                              ?.tenant_id,
                                        currentCN.cn_id
                                      );
                                    }
                                  );
                                }
                              }}
                              type="primary"
                              size="small"
                              loading={cancelIRPLoading}
                            >
                                  Confirm
                            </Button>
                          </div>
                        </React.Fragment>
                      }
                      disabled={cancelIRPLoading}
                    >
                      <div
                        className="push-to-irp__cancel-button"
                        onClick={() => {
                          setCancellationRemarkPop(true);
                        }}
                      >
                        {cancelIRPLoading ? (
                          <LoadingOutlined />
                        ) : (
                          "Cancel"
                        )}
                      </div>
                    </Popover>
                  )}
                </div>
              </React.Fragment>
            }
            type="success"
          />
        )}
        {!isReturnSlip &&
          (currentCN?.e_invoice_status === "FAILED" &&
            currentCN?.e_canceled_date === null ? (
              <PushIRPButtons
                pushIRPLoading={pushCnToIRPLoading}
                pushIRP={() =>
                  pushCnToIRP([{ cn_id: currentCN?.cn_id }], () =>
                    getCNById(
                      Helpers.getTenantEntityPermission(
                        user?.user_tenants,
                        Helpers.permissionEntities.CREDIT_NOTE,
                        Helpers.permissionTypes.READ
                      ).join(",") || user?.tenant_info?.tenant_id,
                      currentCN?.cn_id
                    )
                  )
                }
                selectedInvoice={currentCN}
                type="error"
                tagValue="FAILED"
                tagColor="#ff4d4f"
                iconColor="#ff4d4f"
                message="Pushing to the IRP failed either due to incomplete data or portal issues"
              />
            ) : currentCN?.e_invoice_status === null &&
            currentCN?.e_canceled_date === null ? (
                <PushIRPButtons
                  pushIRPLoading={pushCnToIRPLoading}
                  pushIRP={() =>
                    pushCnToIRP([{ cn_id: currentCN?.cn_id }], () =>
                      getCNById(
                        Helpers.getTenantEntityPermission(
                          user?.user_tenants,
                          Helpers.permissionEntities.CREDIT_NOTE,
                          Helpers.permissionTypes.READ
                        ).join(",") || user?.tenant_info?.tenant_id,
                        currentCN?.cn_id
                      )
                    )
                  }
                  selectedInvoice={currentCN}
                  type="warning"
                  tagValue="YET TO BE PUSHED"
                  tagColor="rgb(236, 149, 0)"
                  iconColor="rgb(236, 149, 0)"
                  message="Push this credit note to the IRP to generate an IRN"
                />
              ) : currentCN?.e_canceled_date ? (
                <Alert
                  className="e-invoice-alert-pushed"
                  message={
                    <div>
                      <span>
                        <FileProtectOutlined
                          style={{
                            color: "#ff4d4f",
                            marginRight: "5px",
                          }}
                        />
                      </span>
                  e-lnvoice <Tag color="#ff4d4f">CANCELED</Tag>
                  on{" "}
                      {currentCN?.e_canceled_date &&
                    toISTDate(currentCN?.e_canceled_date).format(
                      "DD/MM/YYYY hh:mm A"
                    )}
                  .
                      <br />
                  Subsequent generation of an e-Invoice is no longer
                  possible for this particular invoice.
                    </div>
                  }
                  type="warning"
                />
              ) : null)}
      </div>
    )
  )
}

export default ViewCreditNoteEInvoiceInfo;